/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EmployeeExecutionRelativeScheduleUnit } from './EmployeeExecutionRelativeScheduleUnit';
/**
 * Relative schedule selected from workflow instructions.
 */
export type EmployeeExecutionRelativeSchedule = {
    /**
     * Stable discriminator for a relative schedule.
     */
    kind: EmployeeExecutionRelativeSchedule.kind;
    /**
     * Positive whole-number offset from the authoritative anchor.
     */
    amount: number;
    /**
     * Unit applied to the relative schedule offset.
     */
    unit: EmployeeExecutionRelativeScheduleUnit;
};
export namespace EmployeeExecutionRelativeSchedule {
    /**
     * Stable discriminator for a relative schedule.
     */
    export enum kind {
        RELATIVE = 'relative',
    }
}

